// src/pages/Services.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import useSEO from "../seo/useSEO";

export default function Services() {
  useSEO({
    title: "Photographe Mariage & Portrait à Nancy | HLBK",
    description:
      "Photographe à Tomblaine près de Nancy pour mariage, portrait, famille et événement privé. Des images naturelles, vivantes et soignées.",
    canonical: "https://www.hlbk.fr/services",
    image: "https://www.hlbk.fr/images/og-default.jpg",
  });

    const structuredData = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "HLBK Photo",
    url: "https://hlbk.fr/services",
    image: "https://hlbk.fr/images/og-default.jpg",
    description:
      "Photographe à Nancy et Tomblaine spécialisé dans les mariages, portraits, familles et événements privés.",
    areaServed: [
      {
        "@type": "City",
        name: "Nancy",
      },
      {
        "@type": "City",
        name: "Tomblaine",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Nancy",
      },
      {
        "@type": "AdministrativeArea",
        name: "Grand Est",
      },
    ],
    serviceType: [
      "Photographie de mariage",
      "Photographie de portrait",
      "Photographie de famille",
      "Photographie événementielle",
    ],
  };

  const [activeAccordion, setActiveAccordion] = useState(null);

  // construit un mailto prérempli générique
  const buildMailto = (service) => {
    const to = "contact@hlbk.fr";
    const subject = `Demande de devis — ${service}`;
    const body = [
      `Bonjour Maxime,`,
      ``,
      `Je souhaite un devis pour : ${service}`,
      ``,
      `• Date / horaires :`,
      `• Lieu :`,
      `• Type / formule envisagée :`,
      `• Usage des images :`,
      ``,
      `Mes coordonnées :`,
      `• Nom :`,
      `• Email :`,
      `• Téléphone :`,
      ``,
      `Merci !`,
      `— Envoyé depuis hlbk.fr`,
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  // mailto spécifique mariage
  const buildMariageMailto = () => {
    const to = "contact@hlbk.fr";
    const subject = "Mariage — Demande de devis";
    const body = [
      `Bonjour Maxime,`,
      ``,
      `Nous souhaitons recevoir un devis pour notre mariage :`,
      ``,
      `• Date :`,
      `• Lieu :`,
      `• Horaires approximatifs :`,
      `• Nombre d’invités (approx.) :`,
      `• Ce que vous souhaitez couvrir (préparatifs, cérémonie, vin d’honneur, soirée…) :`,
      ``,
      `Nos coordonnées :`,
      `• Prénoms :`,
      `• Email :`,
      `• Téléphone :`,
      ``,
      `Merci !`,
      `— Envoyé depuis hlbk.fr`,
    ].join("\n");

    return `mailto:${to}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  const ServiceCard = ({
  img,
  title,
  desc,
  sections,
  ctaLabel = "DEMANDER UN DEVIS",
  ctaHref,
  detailsLink,
}) => (
    <article className="service-item service-elevated">
      <img className="svc-thumb" src={img} alt={title} />
      <h2 className="svc-title">{title}</h2>
      <p className="svc-blurb">{desc}</p>

      <div className="service-acc">
        {sections.map((section, idx) => {
          const id = `${title}-${idx}`;
          return (
            <details
              key={id}
              className="accordion"
              open={activeAccordion === id}
              onClick={(e) => {
                e.preventDefault();
                setActiveAccordion(activeAccordion === id ? null : id);
              }}
            >
              <summary>{section.label}</summary>
              <div className="accordion-content">{section.content}</div>
            </details>
          );
        })}
      </div>

      <div className="svc-cta-wrap">
  <div className="svc-cta-stack">

    {detailsLink && (
      <Link to={detailsLink} className="cta-secondary">
        Découvrir cette prestation
      </Link>
    )}

    <a
      href={ctaHref || buildMailto(title)}
      className="btn-cta btn-cta-red"
    >
      {ctaLabel}
    </a>

  </div>
</div>
    </article>
  );

  return (
    <section className="services-page">
          <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData),
      }}
    />
      <div className="services-header">
  <p className="section-kicker">PARTICULIERS</p>

  <h1>Vos moments, vos histoires, vos images.</h1>

  <p>
   Mariage, portrait, famille ou événement à Nancy et dans le Grand Est :
  des photographies naturelles, sincères et soignées pour garder
  une trace forte de ce qui compte.
  </p>
</div>
      <div className="services-grid">
        {/* Mariage */}
        <ServiceCard
          img="/images/services/mariage.jpg"
          title="Mariage"
          desc="Revivez l’émotion du jour J avec un reportage discret, vrai et lumineux."
          ctaLabel="DEMANDER UN DEVIS"
          ctaHref={buildMariageMailto()}
          detailsLink="/photographe-mariage-nancy"
          sections={[
            {
              label: "Tarif",
              content: (
                <div className="svc-centered-note">
                  <p style={{ textAlign: "center", margin: 0 }}>
                    <strong>Collections mariage à partir de 850€ TTC</strong>
                  </p>
                  <p
                    style={{
                      textAlign: "center",
                      margin: "10px 0 0",
                      opacity: 0.85,
                    }}
                  >
                    Chaque mariage est unique. Les formules sont ajustées selon
                    la durée, le lieu et vos envies.
                  </p>
                </div>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & naturel</li>
                  <li>Galerie privée</li>
                  <li>Livraison pour web & print</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Séance engagement / Day after — <em>sur demande</em>
                  </li>
                  <li>
                    Livre photo & tirages — <em>sur demande</em>
                  </li>
                  <li>
                    Heure supplémentaire — <em>sur demande</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />

        {/* Portrait */}
        <ServiceCard
          img="/images/services/portrait.jpg"
          title="Portrait"
          desc="Des portraits naturels et soignés — en extérieur ou en studio."
          sections={[
            {
              label: "Tarifs",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Séances extérieur</span>
                    <span className="price-chip">à partir de 150€ TTC</span>
                  </li>
                  <li>
                    <span className="svc-line">Séances studio</span>
                    <span className="price-chip">à partir de 190€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Aucune limite de photos</li>
                  <li>Galerie privée</li>
                  <li>Conseils tenues & lieux</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Tirages — <em>sur demande</em>
                  </li>
                  <li>
                    Album photo — <em>sur demande</em>
                  </li>
                  <li>
                    Déplacement hors Tomblaine — <em>en sus</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />

        {/* Événement */}
        <ServiceCard
          img="/images/services/evenement.jpg"
          title="Événement"
          desc="Anniversaires, baptêmes, soirées privées ou associatives — des images vivantes et sincères."
          sections={[
            {
              label: "Tarif",
              content: (
                <ul className="svc-list centered">
                  <li>
                    <span className="svc-line">Reportage événementiel</span>
                    <span className="price-chip">à partir de 300€ TTC</span>
                  </li>
                </ul>
              ),
            },
            {
              label: "Détails",
              content: (
                <ul className="svc-list">
                  <li>Reportage discret & réactif</li>
                  <li>Galerie privée incluse</li>
                  <li>Livraison HD sécurisée</li>
                </ul>
              ),
            },
            {
              label: "Options",
              content: (
                <ul className="svc-list">
                  <li>
                    Heure supplémentaire — <em>sur demande</em>
                  </li>
                  <li>
                    Tirages / album — <em>sur demande</em>
                  </li>
                </ul>
              ),
            },
          ]}
        />
      </div>
    </section>
  );
}